<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="100">
                <FormItem :label="$t('img_lnk')"  prop="img_link">
                    <myCropImg :fixedNumber="fixedNumber" :autoCropWidthHeight="autoCropWidthHeight" :original_url=this.formData.img_lnk  @cropImgUpload="setImgLnk"></myCropImg>
                </FormItem>
                <FormItem  :label="$t('user_code')" prop="user_code">
                    <Input v-model="formData.user_code" disabled></Input>
                </FormItem>
                <FormItem  :label="$t('user_zh_cname')" prop="user_cname">
                    <Input v-model="formData.user_cname"></Input>
                </FormItem>
                <FormItem  :label="$t('user_tw_cname')" prop="zh-tw_cname">
                    <Input v-model="formData['zh-tw_cname']"></Input>
                </FormItem>
                <FormItem  :label="$t('user_en_cname')" prop="en_cname">
                    <Input v-model="formData.en_cname"></Input>
                </FormItem>
                <FormItem  :label="$t('org_mobile')" prop="user_mobile">
                    <Input v-model="formData.user_mobile"></Input>
                </FormItem>
                <Row>
                    <Col span="8">
                    <FormItem  :label="$t('sex')" prop="user_sex">
                        <Select v-model="formData.user_sex" :placeholder="$t('select')">
                            <Option :value="item.key" v-for="item in user_sexs" :key="item.key">{{item.value}}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <FormItem  :label="$t('birth')" prop="user_birth">
                            <DatePicker type="date" v-model="formData.user_birth" :placeholder="$t('input')" :editable="false"></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="$t('auth_code')" prop="auth_key">
                            <Input v-model="formData.auth_key" :placeholder="$t('input')" @on-enter="onCardNoEnter"></Input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem  :label="$t('cid_code')" prop="cid_code">
                            <Input v-model="formData.cid_code" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <FormItem :label="$t('zhiwei')" prop="zw_cname">
                            <Input v-model="formData.zw_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem  :label="$t('jingyan')" prop="zw_jingyan">
                            <Input v-model="formData.zw_jingyan" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('zhineng')" prop="zw_zhineng">
                    <Input v-model="formData.zw_zhineng" type="textarea" :autosize="{minRows: 5,maxRows: 10}" :placeholder="$t('input')"></Input>
                </FormItem>
                <Row v-if="!$base.isEmpty(this.item)">
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="item.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="item.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row v-if="!$base.isEmpty(this.item)">
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="item.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="item.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    import myCropImg from '../../../components/myCropImg'
    export default {
        data:function(){
            return{
                relist:false,
                fixedNumber:[1,1],
                autoCropWidthHeight:[230,230],
                user_sexs:[],
                formData: {
                    img_lnk:'',
                    user_code: '',
                    user_cname: '',
                    user_mobile: '',
                    user_sex: '',
                    user_birth: '',
                    cid_code: '',
                    auth_key:'',
                    zw_cname:'',
                    zw_jingyan:'',
                    zw_zhineng:'',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    user_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_sex: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    user_pwd: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    'zh-tw_cname': [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    en_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                },
                item: {}
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.item = JSON.parse(this.$base.getRequest().data);
            console.log('this.item', this.item)
            this.formData = this.$base.leftJson(this.formData, this.item)
            this.formData.u_id = this.item.u_id;
            this.getInfo();
        },
        methods:{
            onCardNoEnter:function(){
                this.formData.auth_key = this.$base.getCardNo(this.formData.auth_key)
            },
            setImgLnk: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                this.$base.showLoading();

                this.$request.sendPost("user/before-upd", {},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.user_sexs = data.sexs;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                var url = "user/upd";
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        if(this.formData.user_birth) {
                            this.formData.user_birth = this.$moment(this.formData.user_birth).format("YYYY-MM-DD");
                        }
                        this.$base.showLoading();
                            this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            },
        },
        components: {
            myCropImg,
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_upd.vue